// ----------------------------------------------------------------------------
// Snippet: Shopify Predictive Search
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_predictive-search.scss'

const SEARCH_FORM = '.search-box';
const predictiveSearchResults = '#predictive-search';

// If you click anywhere outside of the search, close it
$('body').on('click', function(event) {
    if (!$(event.target).closest(SEARCH_FORM).length) {
        $(predictiveSearchResults).hide();
    }
});
